import { Button, Checkbox, Loading, Option, RangeDatePicker, Select, TextInput, Tooltip } from '@sede-enterprise/shell-ds-react-framework'
import { useContext, useState } from 'react'
import "./Model.css"
import FilePreview from './FilePreview';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { DownloadCloud, InfoCircle, UploadCloud } from '@sede-enterprise/shell-ds-react-framework/build/esm/components/Icon/components';
import { helperTexts } from '../../util/helperTexts';
import { includesIgnoreCase } from './util/modelUtils';
import useModelLogic from './hooks/useModelLogic';
import { UserContext } from '../../App';
import getModelApiConfig from './util/apiConfig';
import useLogReport from '../../util/hooks/useLogReport';
import { azureFetch } from '../../api/azureFetch';

const algoOptions = [{"label": "XGB", "value": "xgboost"}, {"label": "LGBM", "value": "lightgbm"}]
const modelHelp = helperTexts.modelTraining;

const API_BASE_URL = process.env.REACT_APP_HOST_URL;


const Model = ({ match }) => {

    // Log report for the page
    useLogReport('CAM TRAINING PAGE');

    const { baseHeaders } = getModelApiConfig();

    const history = useHistory()
    const [modelName, setModelName] = useState('');
    const [features, setFeatures] = useState([]);
    const [algoParam, setAlgoParam] = useState('');
    const [exportLoading, setExportLoading] = useState(false);
    const [unitExportLoading, setUnitExportLoading] = useState(false);
    const [trainJobLoading, setTrainJobLoading] = useState(false);
    const { userData } = useContext(UserContext);

    const {
        fileHeaders,
        data,
        trainPeriod,
        allowedtrainPeriod,
        uploadedFileName,
        allowTrain,
        isLoading,
        isUploadEnabled,
        fileBaseUrl,
        fileUploadUrl,
        setIsUploadEnabled,
        setTrainPeriod,
        handleFile,
    } = useModelLogic(match, baseHeaders);


    const getFilteredHeaders = () => {
        return fileHeaders.filter(header => !includesIgnoreCase(["subject", "timestamp", "MeasuredCorrosionRate"], header) && header?.length > 0);
    };


    const trainModelHandler = () => {
        const sites = userData?.map((user => user.target.id)) || [];

        const data = {
            model_display_name: modelName,
            model_name: modelName.replace(/\s+/g, '_') + '_' + new Date().getTime(),
            features: features.join(','),
            parent_model_id: match.params.id,
            csv_file_name: uploadedFileName,
            // units_file_url: exportDataUrl.unit_data,
            train_start: trainPeriod[0]?.format('YYYY-MM-DD'),
            train_end: trainPeriod[1]?.format('YYYY-MM-DD'),
            model_type: algoParam
        }

        console.log("Training model with data: ", data);
        setTrainJobLoading(true);
        azureFetch("triggerModelTrainingJob", data).then((res) => {
            setTrainJobLoading(false);
            toast.success('Model training started successfully');
            history.push(`/models/job/${res.job_id}`);
        }).catch((error) => {
            console.log(error)
            setTrainJobLoading(false);
            toast.error('Error starting model training');
        });
    }


    function downloadExportTrainData() {
        setExportLoading(true);
        fetch(API_BASE_URL + "/DownloadTrainingDataCSV", {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
                Accept: "text/csv",
                Authorization: `Bearer ${localStorage.getItem('authToken')}`
            },
            body: JSON.stringify({ "model_id": match.params.id }),
            // headers: baseHeaders,
            // credentials: 'include'
        }).then((response) => {
            if (response.ok) {
                setIsUploadEnabled(true); // Enable the button if the file is successfully fetched
                return response.blob();
            } else {
                throw new Error('Network response was not ok');
            }
        }).then((blob) => {
            // Create a URL for the Blob and trigger a download
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `${match.params.id}_train_data.csv`; // Set the file name
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url); // Clean up the URL object
            // Read the CSV headers and save them in localStorage
            const reader = new FileReader();
            reader.onload = (event) => {
                const csvContent = event.target.result;
                // // convert csv content as string
                // csvContent = csvContent.toString('utf-8');
                const rows = csvContent.split('\n');
                console.log(rows[0])
                if (rows.length > 0) {
                    const headers = rows[0].split(',').map(header => header.trim());
                    localStorage.setItem(match.params.id, JSON.stringify(headers)); // Save headers in localStorage
                    // toast.success('CSV headers saved to localStorage');
                }
            };
            reader.readAsText(blob);
        })
            .catch((error) => {
                console.log(error);

            }
            ).finally(() => {
                setExportLoading(false);
            });

    }


    function downloadExportUnitData() {
        setUnitExportLoading(true);
        fetch(API_BASE_URL + "/DownloadTrainingDataCSV", {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
                Accept: "text/csv",
                Authorization: `Bearer ${localStorage.getItem('authToken')}`
            },
            body: JSON.stringify({ "model_id": match.params.id, "unit_flag": true }),
            // headers: baseHeaders,
            // credentials: 'include'
        }).then((response) => {
            if (response.ok) {
                return response.blob();
            } else {
                throw new Error('Network response was not ok');
            }
        }).then((blob) => {
            // Create a URL for the Blob and trigger a download
            console.log("blob", blob);
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `${match.params.id}_unit_data.csv`; // Set the file name
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url); // Clean up the URL object
        })
            .catch((error) => {
                console.log(error);

            }
            ).finally(() => {
                setUnitExportLoading(false);
            }
            );
    }

    return (
        <div className='parent-container' >
            <div className='content-container' >
                <div className='content-header' >
                    <h2>Train Model</h2>
                    <div className='header-actions'>
                        <div className='content-body-header'>

                            <Button
                                type="primary"
                                onClick={downloadExportTrainData}
                                icon={<DownloadCloud />}
                                loading={exportLoading}
                            >
                                Export Training Data
                            </Button>

                            <Button
                                type="primary"
                                onClick={downloadExportUnitData}
                                icon={<DownloadCloud />}
                                loading={unitExportLoading}
                            >
                                Export Units Data
                            </Button>

                            <Button
                                type="primary"
                                className="upload-btn upload-btn-custom"
                                onClick={() => document.getElementById('file').click()}
                                icon={<UploadCloud />}
                                disabled={!isUploadEnabled}
                            >
                                Upload Data
                            </Button>
                            <input
                                type="file"
                                id="file"
                                accept=".csv"
                                onChange={handleFile}
                                style={{ display: 'none' }}
                            />

                        </div>
                    </div>

                </div>
                <div className='content-body'>
                    <FilePreview data={data} headers={fileHeaders} fileName={uploadedFileName} />
                    <br />
                    {allowTrain ? <div className='model-form'>
                        <div className='model-form-row-1'>
                            <div className='model-name'>
                                <div className='label-header'>
                                    <div className={'data-label'}>Model Name</div>
                                    <Tooltip className='tooltip' placement='bottom' overlay={<div className='tooltip-content'>{modelHelp.modelName}</div>} trigger={
                                        <Button variant='transparent' iconOnly icon={<InfoCircle />} />
                                    } />
                                </div>
                                <TextInput placeholder='Add Your Model Name'
                                    value={modelName}
                                    onChange={(e) => setModelName(e.target.value)}
                                />
                            </div>
                            <div className='selected-features'>
                                <div className='feature-header'>
                                    <div className='label-header'>
                                        <div className={'data-label'}>Features</div>
                                        <Tooltip className='tooltip' placement='bottom' overlay={<div className='tooltip-content'>{modelHelp.features}</div>} trigger={
                                            <Button variant='transparent' iconOnly icon={<InfoCircle />} />
                                        } />

                                    </div>
                                    <Checkbox
                                        label="Select All Features"
                                        checked={features.length === getFilteredHeaders().length && features.length > 0}
                                        indeterminate={features.length > 0 && features.length < getFilteredHeaders().length}
                                        onChange={e => {
                                            if (e.target.checked) {
                                                setFeatures(getFilteredHeaders());
                                            } else {
                                                setFeatures([]);
                                            }
                                        }}
                                        disabled={fileHeaders.length === 0}
                                    />
                                </div>

                                <Select placeholder="Select Features" mode='multiple' value={features} showSearch={true} onChange={(value) => setFeatures(value)} disabled={fileHeaders.length === 0}>
                                    {getFilteredHeaders().map((header, index) => {
                                        return <Option key={index} value={header}>{header}</Option>
                                    })}
                                </Select>

                            </div>
                            <div className='selected-algo'>
                                <div className='label-header'>
                                    <div className={'data-label'}>Model Type</div>
                                    <Tooltip className='tooltip' placement='bottom' overlay={<div className='tooltip-content'>{modelHelp.model}</div>} trigger={
                                        <Button variant='transparent' iconOnly icon={<InfoCircle />} />
                                    } />
                                </div>
                                <Select placeholder="Select Algorithm" onChange={(value) => setAlgoParam(value)} disabled={fileHeaders.length === 0}>
                                    {algoOptions.map((option, index) => {
                                        return <Option key={index} value={option.value}>{option.label}</Option>
                                    })}
                                </Select>
                            </div>
                            <div className='train-period'>
                                <div className='label-header'>
                                    <div className={'data-label'}>Train Period</div>
                                    <Tooltip className='tooltip' placement='bottom' overlay={<div className='tooltip-content'>{modelHelp.trainPeriod}</div>} trigger={
                                        <Button variant='transparent' iconOnly icon={<InfoCircle />} />
                                    } />
                                </div>
                                <RangeDatePicker placeholder={['Start date', 'End Date']} disabled={fileHeaders.length === 0}
                                    allowClear={false}
                                    value={trainPeriod}
                                    onChange={(value) => {
                                        if (value) {
                                            setTrainPeriod([
                                                value[0],
                                                value[1]
                                            ])
                                        }

                                    }}
                                    disabledDate={(curr) => curr ? (curr.isBefore(allowedtrainPeriod[0]) || curr.isAfter(allowedtrainPeriod[1])) : false}
                                />
                            </div>
                        </div>
                        <br />
                        <div className='model-form-row-2'>
                            <   Button type='primary' disabled={fileHeaders.length === 0} onClick={trainModelHandler} loading={trainJobLoading}>Train Model</Button>
                        </div>
                        <br />
                    </div> : !isLoading ? <div className='model-default-msg'>
                        <h4>Upload valid data to train model.</h4>
                    </div> :
                        <div className='loading-container' role='status'>
                            <Loading />
                        </div>
                    }

                </div>
            </div>
            <br />
            <br />
        </div>
    )
}

export default Model